// extracted by mini-css-extract-plugin
module.exports = {"summary":"s5pdrTje7c8YbqBLxtX5k"};